import { Controller } from "@hotwired/stimulus";
import Avatar from "avatar-initials";

// Connects to data-controller="medical_pet_shirts"
export default class extends Controller {
  static targets = ["avatar"];

  connect() {
    document.documentElement.style.setProperty("--company-primary-color", "#25345E");
    document.documentElement.style.setProperty("--bs-primary-rgb", "37, 52, 94");
    document.documentElement.style.setProperty("--company-dark-color", "#272727");
    document.documentElement.style.setProperty("--company-primary-color-darker", "#232d49");
    document.documentElement.style.setProperty("--company-primary-gradient-color", "#232d49");
    document.documentElement.style.setProperty("--company-secondary-gradient-color", "#25345E");
    document.documentElement.style.setProperty("--company-muted-color", "#d7d9e0");
  }

  avatarTargetConnected(element) {
    const initials = element.dataset.initials;
    Avatar.from(element, {
      useGravatar: false,
      initials: initials,
      color: "white",
      background: "#25345E",
      fontWeight: 100,
      fontFamily: "'Raleway', 'Lato', 'Lato-Regular', 'Helvetica Neue'",
      fontSize: 18,
      width: 50,
      height: 50,
    });
  }
}
